<button type="button" class="bo-auth-social" (click)="pressed.emit()" [attr.aria-label]="ariaLabel()">
  <span class="bo-auth-social__icon" aria-hidden="true">
    <ng-content select="[icon]"></ng-content>
  </span>
  <span>{{ label() }}</span>
</button>
